import { ViewerModule } from '@g.frame/core';
import { Color, Vector2 } from 'three';
import { FONT } from '@g.frame/common.loaders';
import { TextComponent } from '@g.frame/components.text';
const styleConfig = {
    color: new Color('#432A1C'),
    background: new Color('#FFF3DD'),
};
export default class BodyTextElement extends ViewerModule {
    constructor(loader, textComponentFactory) {
        super();
        this.loader = loader;
        this.textComponentFactory = textComponentFactory;
        this.loader.addResources([
            {
                name: 'ProximaNova&otf-600-normal',
                url: require('../../assets/proximanova.otf'),
                // url: require('../../assets/Ubuntu-Bold.ttf'),
                type: FONT
            },
        ]);
        this.uiObject.name = 'BodyText';
    }
    set(newOptions) {
        if (newOptions) {
            this.oldOptions = this.options;
            this.options = newOptions;
        }
        this.bodyText && this.disposeObject(this.bodyText);
        this.resultSize = this.options.window.size.clone().multiplyScalar(this.options.window.scale);
        this.initText();
    }
    initText() {
        const bodySize = this.resultSize.clone();
        this.addObject(this.bodyText = this.textComponentFactory.getFactory(TextComponent)({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * this.options.window.pxScale, 256 * this.options.window.pxScale),
            text: {
                value: this.options.text,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '600',
                    size: '183px',
                    color: this.options.invertedColors ? styleConfig.background.getStyle() : styleConfig.color.getStyle()
                },
                margin: 0.001,
                lineHeight: 182,
            },
            background: {
                color: this.options.invertedColors ? styleConfig.color.getStyle() : styleConfig.background.getStyle()
                // color: 'transparent'
            }
        }));
    }
}
